var $f8c49dd804b75140$exports = {};
$f8c49dd804b75140$exports = {
  "breadcrumbs": "\u5C0E\u89BD\u5217"
};
export { $f8c49dd804b75140$exports as default };